import { SORT_ORDERS, SortOrder } from '../common/sorter-order';

export type SortField = string;

export const DEFAULT_SORT_FIELD: SortField = 'order';
export const DEFAULT_SORT_ORDER: SortOrder = SORT_ORDERS.descend;
